<app-party-list
	[data]="data"
	[mode]="mode"
	[keyMapModel]="keyMapModel"
	[dataType]="dataType"
	(appInput)="input$$.next($event)"
	(appSelect)="select($event)"
	(appScrolled)="onScrolled()">
</app-party-list>
